<template>
  <div class="feedback">
    <transition name="fade" @enter="enterFeedback">
      <feedback-success v-if="showableFeedback" :message="'ログインしました'" />
    </transition>
  </div>
</template>
<script>
import FeedbackSuccess from '../../atoms/feedbacks/feedback-success.vue'

export default {
  components: {
    FeedbackSuccess
  },
  props: {
    isSuccessLogin: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      showableFeedback: false
    }
  },
  mounted() {
    this.showableFeedback = this.isSuccessLogin
  },
  methods: {
    enterFeedback() {
      setTimeout(() => {
        this.showableFeedback = false
      }, 3000)
    }
  }
}
</script>
